export const themeKind = {
  dark: 'NIGHT',
  light: 'DAY',
};
